//This file includes extra functions regarding layer manipulation
import { observable, makeAutoObservable } from 'mobx'
import { SelectBox } from './componentStore';


class LayerStore {
  @observable workAreaStore

  constructor(workAreaStore) {
    makeAutoObservable(this);
    this.workAreaStore = workAreaStore
  }
  selectBox = null
  mouseStartX = 0
  mouseStartY = 0
  startX = 0
  startY = 0
  wait = false
  //Store all IDs that overlap the selection in an array as it's more light weight
  overlapIds = []

  initSelectBox() {
    this.selectBox = new SelectBox(0, 0, 0, 0, [])
  }

  handleDrawMouseDown(clientX, clientY) {
    this.wrapper = document.querySelector('.select-box-wrapper')
    if(!this.selectBox){
      return
    }
    const { top, left } = this.wrapper.getBoundingClientRect()
    this.workAreaStore.isSelecting = true
    this.mouseStartX = clientX
    this.mouseStartY = clientY
    const zoom = (this.workAreaStore.zoom / 100)
    let xCord = (clientX - left) / zoom
    let yCord = (clientY - top) / zoom
    this.selectBox.xPos = xCord
    this.selectBox.yPos = yCord
    this.startX = xCord
    this.startY = yCord
  }

  handleDrawMouseUp() {
    this.workAreaStore.isSelecting = false
    this.mouseStartX = 0
    this.mouseStartY = 0
    if(!this.selectBox){
      return
    }
    this.selectBox.xPos = 0
    this.selectBox.yPos = 0
    this.selectBox.width = 0
    this.selectBox.height = 0
    this.startX = 0
    this.startY = 0
    if (this.overlapIds.length) {
      this.workAreaStore.groupLayersById(this.overlapIds)
      this.workAreaStore.unsetActivePage()
      this.overlapIds = []
    }
  }

  drawBox(clientX, clientY) {
    const { xPos, yPos, width, height } = this.selectBox
    const zoom = (this.workAreaStore.zoom / 100)
    let moveX = (clientX - this.mouseStartX) / zoom
    let moveY = (clientY - this.mouseStartY) / zoom
    const absX = Math.abs(moveX)
    const absY = Math.abs(moveY)
    if (moveX < 0) {
      let offset = xPos + width
      if (this.startX >= offset) {
        this.selectBox.xPos -= absX
        this.selectBox.width += absX
      }
      if (this.startX === xPos) {
        this.selectBox.width -= absX
      }
      if (this.startX < this.selectBox.xPos) {
        this.selectBox.width -= absX
      }
    }
    if (moveX > 0) {
      if (this.startX > this.selectBox.xPos) {
        this.selectBox.xPos += absX
        this.selectBox.width -= absX
      } else {
        this.selectBox.width += absX
      }
    }
    if (moveY < 0) {
      const offset = yPos + height
      if (this.startY >= offset) {
        this.selectBox.yPos -= absY
        this.selectBox.height += absY
      }
      if (this.startY === yPos) {
        this.selectBox.height -= absY
      }
      if (this.startY < yPos) {
        this.selectBox.height -= absY
      }
    }
    if (moveY > 0) {
      if (this.startY > yPos) {
        this.selectBox.yPos += absY
        this.selectBox.height -= absY
      } else {
        this.selectBox.height += absY
      }
    }
    //Set debounce for layer overlap check for performance reasons
    if (!this.wait) {
      this.wait = true
      this.checkLayerOverlap()
      setTimeout(() => {
        this.wait = false
      }, 50)
    }
    this.mouseStartX = clientX
    this.mouseStartY = clientY
  }

  checkLayerOverlap() {
    const layers = this.workAreaStore.getAllLayers()
    const domLayers = document.querySelectorAll('.layer .layer-content-wrapper')
    const { left, top, width, height } = document.querySelector('.select-box').getBoundingClientRect()
    const zoom = this.workAreaStore.zoom / 100
    const right = left + width
    const bottom = top + height
    domLayers.forEach(domLayer => {
      const rect = domLayer.getBoundingClientRect()
      const yOverlap = (rect.top <= top && rect.bottom >= top) || (rect.top <= bottom && rect.bottom >= bottom) || (rect.top >= top && rect.bottom <= bottom)
      const xOverlap = (rect.left <= left && rect.right >= left) || (rect.left <= right && rect.right >= right) || (rect.left >= left && rect.right <= right)
      const layerId = atob(domLayer.getAttribute('data-id'))
      const idx = this.overlapIds.findIndex(id => id === layerId)
      if (yOverlap && xOverlap) {
        if (idx === -1) {
          this.overlapIds.push(layerId)
        }
      } else {
        if (idx !== -1) {
          this.overlapIds = this.overlapIds.filter(id => id !== layerId)
        }
      }
    })
  }


  getPageStyle(page, tools = false, nocolor = false, basePage = false, noBg = false, filterPage = false){
    const { displayHeight, displayWidth, background, backgroundUrl, transparent, backgroundPosition, backgroundHeight, backgroundWidth, filters } = page
    const style = {
      height: displayHeight,
      width: displayWidth,
    }
    try{
      const zoom = this.zoom / 100
      if(filterPage && filters){
        const { 
          opacity,
          blur,
          saturation,
          brightness,
          contrast
        } = filters
        style.filter =`blur(${blur / 10}px) opacity(${opacity / 100}) contrast(${contrast / 100}) brightness(${brightness / 100}) saturate(${saturation / 100})`
        style.backgroundImage = `url("${backgroundUrl}")`
        style.backgroundSize = `${backgroundWidth}px ${backgroundHeight}px`
        style.backgroundPosition = backgroundPosition ? `${backgroundPosition.x}px ${backgroundPosition.y}px` : 'center'
        return style
      }
      if(transparent){
        let url = `/design-editor/t-bg.svg`
        style.background = `url("${url}")`
        style.backgroundSize = `${20 / zoom}px`
        style.backgroundRepeat = 'repeat'
        return style
      }
      if(nocolor){
        return style
      }
      if(backgroundUrl && !tools){
        //style.backgroundImage = `url("${backgroundUrl}")`
        //style.backgroundSize = `${backgroundWidth}px ${backgroundHeight}px`
        //style.backgroundPosition = backgroundPosition ? `${backgroundPosition.x}px ${backgroundPosition.y}px` : 'center'
      }else{
        style.backgroundColor = background
      }
      if(noBg){
        delete style.backgroundImage
        delete style.backgroundColor
      }
      if(!basePage){
        delete style.backgroundColor
      }
      if(basePage){
        style.backgroundColor = background
      }
      return style
    }catch(err){
      console.log(err)
      return style
    }
  }

  findLayerById(layerId){
    let found = false
    let layer = null
    this.workAreaStore.pages.forEach(page => {
      if(!found){
        page.layers.forEach(l => {
          if(l.id === layerId){
            layer = l
          }
        })
      }
    })
    return layer
  }

}

export default LayerStore